import MetaOperatorList from './MetaOperatorList';
import MetaField from './MetaField';
import MetaOperator from './MetaOperator';

class MetaQueryField extends MetaField {
  constructor(args = {}) {
    const {
      data = {},
    } = args;

    const {
      operators,
      ...restData
    } = data;

    super({
      ...args,
      data: restData,
    });

    this.operatorList = new MetaOperatorList({ data: operators, parent: this });
  }

  export() {
    const superExport = super.export();

    return {
      ...superExport,
      operators: this.operatorList.list().map(v => v.export()),
    };
  }

  merge(other) {
    if (!this.shouldMerge(other)) {
      return;
    }

    super.merge(other);

    this.operatorList.merge(other.operatorList);

    return this;
  }

  operators() {
    return this.operatorList;
  }

  operator(key) {
    if (key === undefined) {
      throw new Error('Usage: Key is required.');
    }

    const operator = this.operatorList.item(key);

    if (!operator) {
      return null;
    }

    return operator;
  }
}

export default MetaQueryField;
